import { createContext } from "react";

/**
 * Module boundary: Provider + hook must share one context identity.
 * Keeps a single instance if BookingFlowContext.jsx is evaluated twice (cycles/HMR).
 */
export const BookingFlowContext = createContext(null);
